import { useApiFetcherSWR } from "hooks/SwrCustom";
import axiosInstance from "Api";

export const AFAS_KOPPELING_API = {
    GET_CONNECTION: (communityId) => ({
        url: `bestuur/afas-koppeling/${communityId}`,
        method: "get",
    }),
    GET_ENVIRONMENTS: {
        url: "bestuur/afas-koppeling/environments",
        method: "get",
    },
    SAVE_CONNECTION: {
        url: "bestuur/afas-koppeling",
        method: "post",
    },
    /** Read-only debug overview (no AFAS writes). */
    GET_DEBUG: (communityId) => ({
        url: `bestuur/afas-koppeling/${communityId}/debug`,
        method: "get",
    }),
};

export const useAfasConnection = (communityId) =>
    useApiFetcherSWR(
        communityId
            ? AFAS_KOPPELING_API.GET_CONNECTION(communityId)
            : null
    );

export const useAfasEnvironments = () =>
    useApiFetcherSWR(AFAS_KOPPELING_API.GET_ENVIRONMENTS);

export const useSaveAfasConnection = () =>
    useApiFetcherSWR(AFAS_KOPPELING_API.SAVE_CONNECTION);

export const useAfasDebugOverview = (communityId, enabled = true) =>
    useApiFetcherSWR(
        communityId && enabled
            ? AFAS_KOPPELING_API.GET_DEBUG(communityId)
            : null
    );

/**
 * Live GET receive probe (allowlisted connector, read host only).
 * @param {number} communityId
 * @param {string} connector
 * @param {number} [take=5]
 */
export const fetchAfasDebugReceive = (communityId, connector, take = 5) =>
    axiosInstance.get(
        `bestuur/afas-koppeling/${communityId}/debug/receive`,
        { params: { connector, take } },
    );

/**
 * Local afas_batches payloads for debug (never posts to AFAS).
 * @param {number} communityId
 * @param {number} [limit=10]
 */
export const fetchAfasDebugBatches = (communityId, limit = 10) =>
    axiosInstance.get(
        `bestuur/afas-koppeling/${communityId}/debug/batches`,
        { params: { limit } },
    );
